import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const StyledExpandMoreIcon = styled(ExpandMoreIcon)({
    color: 'white'
});

export default StyledExpandMoreIcon;
